// Define base configurations for each business category
export const REVIEW_CONFIGS = {
  // LODGING - Hotels, Motels, Resorts, etc.
  lodging: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
      { key: "roomRating", label: "Room" },
      { key: "serviceRating", label: "Service" },
      { key: "locationRating", label: "Location" }
    ],
    tripTypeQuestion: "Trip Type",
    travelWithQuestion: "Travel With",
    descriptionQuestion: "Hotel Description",
  },

  // FOOD & BEVERAGE - Restaurants, Cafes, Bakeries, etc.
  food_beverage: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
      { key: "foodRating", label: "Food" },
      { key: "serviceRating", label: "Service" },
      { key: "ambienceRating", label: "Atmosphere" }
    ],
    tripTypeQuestion: "Meal Type",
    travelWithQuestion: "Price per person",
    descriptionQuestion: "Seating Type",
  },

  
  // HOME SERVICES - Plumbers, Electricians, HVAC, etc.
  home_services: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
      
    ],
    tripTypeQuestion: "How would you describe the price you paid?",
    travelWithQuestion: "How much did you pay for the service?",
    descriptionQuestion: "Which services did you get?",
  },

 

  // BEAUTY & WELLNESS - Salons, Spas, etc.
  beauty_wellness: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
     
    ],
    tripTypeQuestion: null,
    travelWithQuestion: "Price per person",
    descriptionQuestion: "Which services did you get?",
  },

 

  // AUTOMOTIVE - Car services
  automotive: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
      { key: "qualityRating", label: "Quality" },
      { key: "priceRating", label: "Price" },
      { key: "serviceRating", label: "Service" }
    ],
    tripTypeQuestion: "Service Type",
    travelWithQuestion: null,
    descriptionQuestion: null,
  },

  // EDUCATION & CHILDCARE
  education: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" },
      { key: "instructionRating", label: "Instruction" },
      { key: "facilityRating", label: "Facility" },
      { key: "valueRating", label: "Value" }
    ],
    tripTypeQuestion: null,
    travelWithQuestion: null,
    descriptionQuestion: null,
  },

  // DEFAULT - Generic fallback
  default: {
    ratingCategories: [
      { key: "overAllRating", label: "Overall" }
    ],
    tripTypeQuestion: null,
    travelWithQuestion: null,
    descriptionQuestion: null,
  }
};

// Map business types to their category
const BUSINESS_TYPE_CATEGORY_MAP = {
  // Lodging
  hotel: "lodging",
  motel: "lodging",
  extended_stay_hotel: "lodging",
  budget_hotel: "lodging",
  inn: "lodging",
  hostel: "lodging",
  resort_hotel: "lodging",
  vacation_home_rental_agency: "lodging",
  cabin_rental_agency: "lodging",
  short_term_apartment_rental_agency: "lodging",
  rv_park: "lodging",
  campground: "lodging",

  // Legal
  personal_injury_attorney: "default",
  workers_compensation_attorney: "default",
  criminal_justice_attorney: "default",
  immigration_attorney: "default",
  family_law_attorney: "default",
  divorce_attorney: "default",
  bankruptcy_attorney: "default",
  estate_planning_attorney: "default",
  employment_attorney: "default",
  tax_attorney: "default",
  social_security_attorney: "default",

  // Healthcare
  dentist: "default",
  pediatric_dentist: "default",
  orthodontist: "default",
  periodontist: "default",
  emergency_dental_service: "default",
  urgent_care_center: "default",
  chiropractor: "default",
  pain_management_physician: "default",
  physical_therapy_clinic: "default",
  weight_loss_service: "default",
  sleep_clinic: "default",
  dermatologist: "default",
  veterinarian: "default",

  // Home Services
  hvac_contractor: "home_services",
  plumber: "home_services",
  electrician: "home_services",
  roofing_contractor: "home_services",
  general_contractor: "default",
  foundation_repair_service: "home_services",
  fence_contractor: "home_services",
  water_damage_restoration_service: "home_services",
  pest_control_service: "default",
  garage_door_supplier: "default",
  solar_energy_contractor: "default",
  pool_cleaning_service: "default",
  painting_contractor: "default",
  landscaper: "default",
  lawn_care_service: "default",
  gutter_cleaning_service: "default",
  house_cleaning_service: "default",
  locksmith: "default",

  // Retail
  furniture_store: "default",
  auto_parts_store: "default",
  used_car_dealer: "default",
  vape_shop: "default",
  pet_supply_store: "default",
  cell_phone_store: "default",
  mobile_phone_repair_shop: "default",
  jewelry_store: "default",
  organic_food_store: "default",
  medical_supply_store: "default",
  flower_shop: "default",

  // Food & Beverage
  indian_restaurant: "food_beverage",
  pizza_restaurant: "food_beverage",
  fast_food_restaurant: "food_beverage",
  cafe: "food_beverage",
  bakery: "food_beverage",
  ice_cream_shop: "food_beverage",
  juice_shop: "food_beverage",

  // Beauty & Wellness
  beauty_salon: "beauty_wellness",
  nail_salon: "beauty_wellness",
  hair_salon: "beauty_wellness",
  spa: "beauty_wellness",
  massage_spa: "beauty_wellness",
  tattoo_shop: "beauty_wellness",
  barber_shop: "beauty_wellness",
  pet_groomer: "beauty_wellness",

  // Professional Services
  marketing_agency: "default",
  real_estate_agency: "default",
  property_management_company: "default",
  accounting_firm: "default",
  insurance_agency: "default",
  it_support_service: "default",
  software_company: "default",
  website_designer: "default",
  business_consultant: "default",
  logistics_service: "default",
  security_guard_service: "default",

  // Automotive
  auto_repair_shop: "default",
  auto_body_shop: "default",
  car_wash: "default",
  car_detailing_service: "default",
  towing_service: "default",

  // Education & Childcare
  day_care_center: "default",
  music_school: "default",
  martial_arts_school: "default",

  // Other Services
  dry_cleaner: "default",
};

// Get review configuration based on business type
export const getReviewConfig = (businessType) => {
  const normalizedType = businessType?.toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
  const category = BUSINESS_TYPE_CATEGORY_MAP[normalizedType] || "default";
  return REVIEW_CONFIGS[category];
};
  
  
  